import * as React from 'react'
import { useState } from 'react'
import { getQuery, setQuery } from "../../../../../services/local-session-storage"
import VehiclesModel, { vehiclesToProductDetail } from "../../../../../models/vehicles.model";
import { ListWithInfo } from "../../components/list-with-info";
import { ProductDetailDrawer } from "../products/product-detail-drawer";
import { flexFilter, orderObjectArray } from "../../../../../utils";
import { Box, Typography, useTheme } from "@mui/material";
import WizardShell from "../../../../../components/ui/WizardShell";
import { TOPIC_STEPS } from "../../wizard-steps";
import { SearchField } from "../../../../../components/ui";

type Props = {
    vehicles: VehiclesModel[]
    onFinish: () => void
    onBack: () => void
}

export const Vehicles: React.FC<Props> = ({ onFinish, onBack, vehicles }) => {
    const theme = useTheme()
    const model = getQuery()
    const [open, setOpen] = useState(false)
    const [filter, setFilter] = useState('')
    const [toOpenVehicle, setToOpenVehicle] = useState<VehiclesModel | null>()
    const [selectedVehicle, setSelectedVehicle] = useState<VehiclesModel | null>(model.vehicles || null)

    const handleClickVehicles = (id: number) => {
        setOpen(true)
        const model = vehicles.find(elem => elem.id === id)
        setToOpenVehicle(model)
    }

    const handleSelectVehicles = (id: number) => {
        if (selectedVehicle?.id === id) {
            setSelectedVehicle(null)
            return
        }
        const model = vehicles.find(elem => elem.id === id)
        if (model) setSelectedVehicle(model)
    }

    const handleContinue = () => {
        setQuery({ vehicles: selectedVehicle })
        onFinish()
    }

    const isElementChecked = (vehicle: VehiclesModel) => {
        return selectedVehicle?.id === vehicle.id
    }

    const selectedCount = selectedVehicle ? 1 : 0

    return (
        <WizardShell
            steps={[...TOPIC_STEPS]}
            activeIndex={3}
            onBack={onBack}
            onNext={handleContinue}
        >
            <ProductDetailDrawer
                open={open}
                detail={vehiclesToProductDetail(toOpenVehicle)}
                onClose={() => setOpen(false)}
                typeLabel="Veículo"
            />

            {/* Header */}
            <Box sx={{ display: "flex", alignItems: "baseline", gap: 1.5, mb: "24px" }}>
                <Typography
                    sx={{
                        fontFamily: theme.typography.fontFamilyDisplay,
                        fontSize: { xs: 20, md: 24 },
                        fontWeight: 400,
                        color: "text.primary",
                    }}
                >
                    Veículo
                </Typography>
                <Typography
                    sx={{
                        fontSize: 13,
                        px: 1.5,
                        py: 0.4,
                        borderRadius: "100px",
                        border: `1px solid ${theme.palette.brand.heroBorder}`,
                        backgroundColor: theme.palette.brand.cream,
                        color: "primary.dark",
                    }}
                >
                    opcional · {selectedCount} selecionado
                </Typography>
            </Box>

            {/* Search */}
            <SearchField
                value={filter}
                onChange={(v) => setFilter(v)}
                sx={{ mb: "16px" }}
            />

            {/* List */}
            <Box
                sx={{
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: "13px",
                }}
            >
                {orderObjectArray(flexFilter(vehicles, "name", filter))
                    .by('name')
                    .asc()
                    .map((vehicle, index, arr) =>
                        <ListWithInfo
                            key={vehicle.id}
                            id={vehicle.id}
                            name={vehicle.name}
                            checked={isElementChecked(vehicle)}
                            onClick={(id) => handleClickVehicles(id)}
                            onSelect={(id) => handleSelectVehicles(id)}
                            isLast={index === arr.length - 1}
                            isSelected={isElementChecked(vehicle)}
                        />
                    )
                }
            </Box>
        </WizardShell>
    )
}
